import { AdmissionUpdateResponse } from '@quromedical/models';
import { admissionClassDisplay, admissionStatusDisplay } from 'core/display';
import { FormCard, Text } from 'design-system';
import React from 'react';
import { strings } from 'strings';

interface AdmissionStatusDisplayProps {
  admission?: Partial<AdmissionUpdateResponse>;
  title?: string;
}

export const AdmissionStatusDisplay: React.FC<AdmissionStatusDisplayProps> = ({
  admission = {},
  title,
}) => {
  return (
    <FormCard
      title={title}
      rows={[
        {
          fields: [
            {
              type: 'custom',
              label: strings.AdmissionStatusLabel,
              Display: () => <Text>{admissionStatusDisplay[admission.status || 'unknown']}</Text>,
            },
            {
              type: 'custom',
              label: strings.AdmissionServiceLabel,
              Display: () => (
                <Text>{(admission.class && admissionClassDisplay[admission.class]) || ''}</Text>
              ),
            },
          ],
        },
      ]}
    />
  );
};
